@if (!inputService.hidden && inputService.formInputDefinition && inputService.control) {
  <ng-container [formGroup]="inputService.formGroup">
    <mat-checkbox value='1'
      [ngClass]='$safeNavigationMigration(inputService?.formInputDefinition?.inputConfig?.customCssClass)'
      [formControlName]='inputService.formControlKey'
      [matTooltip]='inputService.formInputDefinition.titleIcon ? null : inputService.formInputDefinition.titleTooltip'
      [disabled]='inputService.inputConfig.readOnly'>
      <span>
        {{inputService.formInputDefinition.name | translate}}
        @if (inputService.formInputDefinition.titleIcon) {
          <mat-icon class='title-input-icon' [matTooltip]='inputService.formInputDefinition.titleTooltip'>{{inputService.formInputDefinition.titleIcon}}</mat-icon>
        }
      </span>
    </mat-checkbox>
  </ng-container>
}